import AppBar from "@material-ui/core/AppBar";
import { loadStripe } from "@stripe/stripe-js";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import { Button, Card, CardActions, CardContent, CardHeader, CircularProgress, Grid } from "@material-ui/core";
import StarIcon from '@material-ui/icons/Star';
import { theme } from "../assets/theme";
import firebase from "../assets/firebase";
import { useState } from "react";
import { Dispatch } from "react";
import { useDispatch, useSelector } from "react-redux";
import { StateAction } from "./state/actions/actions";
import { StateInterface } from "./state/reducer/store";
const useStyles = makeStyles((theme) => ({
  "@global": {
    ul: {
      margin: 0,
      padding: 0,
      listStyle: "none",
    },
  },
  appBar: {
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  toolbar: {
    flexWrap: "wrap",
  },
  toolbarTitle: {
    flexGrow: 1,
  },
  link: {
    margin: theme.spacing(1, 1.5),
  },
  heroContent: {
    padding: theme.spacing(8, 0, 6),
  },
  cardHeader: {
    backgroundColor:
      theme.palette.type === "light"
        ? theme.palette.grey[200]
        : theme.palette.grey[700],
  },
  cardPricing: {
    display: "flex",
    justifyContent: "center",
    alignItems: "baseline",
    marginBottom: theme.spacing(2),
  },
  footer: {
    borderTop: `1px solid ${theme.palette.divider}`,
    marginTop: theme.spacing(8),
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    [theme.breakpoints.up("sm")]: {
      paddingTop: theme.spacing(6),
      paddingBottom: theme.spacing(6),
    },
  },
}));

// const tiers = [
//   {
//     title: "Basic",
//     price: "FREE",
//     description: [
//       "Free text to speech in over 40 languages.",
//       "Only supports basic voices.",
//       "1000 free Neural Voice credits.",
//       "Supports over 10 file formats.",
//       "Convert any image or PDF to text.",
//       "Daily limit of 5000 characters/day.",
//       "Unable to save audio files",
//       "Unable to voice gender",
//       "Unable to adjust pitch or speaking rate"

//     ],
//     buttonText: "Sign Up For Free!",
//     buttonVariant: "outlined",
//     id: 'Basic'
//   },
//   {
//     title: "Pro",
//     subheader: "/ Month",
//     price: "$9",
//     description: [
//       "Free text to speech in over 40 languages.",
//       "Access to over 200 voices in 40 languages",
//       "50,000 free Neural Voice credits.",
//       "Supports over 10 file formats.",
//       "Convert any image or PDF to text.",
//       "Free storage of converted audio files",
//       "Ability to adjust pitch and speaking rate",
//       "Ability to choose between .wav or .mp3 audio format"

//     ],
//     buttonText: "Sign Up",
//     buttonVariant: "outlined",
//     id: config.products.membership.monthly
//   },
//   {
//     title: "Pro",
//     price: "$99",
//     subheader: "/ Year",
//     description: [
//       "Free text to speech in over 40 languages.",
//       "Access to over 200 voices in 40 languages",
//       "500,000 free Neural Voice credits.",
//       "Supports over 10 file formats.",
//       "Convert any image or PDF to text.",
//       "Free storage of converted audio files",
//       "Ability to adjust pitch and speaking rate",
//       "Ability to choose between .wav or .mp3 audio format"

//     ],
//     buttonText: "Sign Up",
//     buttonVariant: "outlined",
//     id: config.products.membership.yearly
//   },

// ];





export default function Pricing() {
  const classes = useStyles();
  const [goingToStripe, setGoingToStripe] = useState('');
  const dispatch: Dispatch<StateAction> = useDispatch();
  const config = useSelector((state: StateInterface) => state.config)

  const sendToCheckout = async (userId: string, productId: string) => {
    const typeOfTransaction = Object.values(config.products.membership).includes(productId) ? {
      price: productId,
      success_url: window.location.origin,
      cancel_url: window.location.origin,
      metadata: {
        uid: firebase.auth().currentUser?.uid,
      },
    } : {
      mode: "payment",
      price: productId,
      success_url: window.location.origin,
      cancel_url: window.location.origin,
      metadata: {
        uid: firebase.auth().currentUser?.uid,
      },
    }
    const docRef = await firebase.firestore()
      .collection('users')
      .doc(userId)
      .collection('checkout_sessions')
      .add(typeOfTransaction)
    docRef.onSnapshot(async (snap: firebase.firestore.DocumentSnapshot<firebase.firestore.DocumentData>) => {
      const { error, sessionId } = snap.data() || {};
      if (error) {
        console.error(error)
      }
      if (sessionId) {
        const stripe = await loadStripe(config.stripe_key)
        stripe?.redirectToCheckout({ sessionId })
      }
    })
  }


  const characterPacks = [
    {
      title: `50,000 ${config.textByLanguage.neuralVoiceCharacters}`,
      price: "$10",
      description: [
        `50,000 ${config.textByLanguage["priceBlockPoint.1"]}`,
        config.textByLanguage["priceBlockPoint.2"],
        config.textByLanguage["priceBlockPoint.3"],
        config.textByLanguage["priceBlockPoint.4"]
      ],
      buttonText: config.textByLanguage.buyText,
      buttonVariant: "outlined",
      id: config.products.characterPack[50000]
    },
    {
      title: `100,000 ${config.textByLanguage.neuralVoiceCharacters}`,
      subheader: "",
      price: "$20",
      description: [
        `100,000 ${config.textByLanguage["priceBlockPoint.1"]}`,
        config.textByLanguage["priceBlockPoint.2"],
        config.textByLanguage["priceBlockPoint.3"],
        config.textByLanguage["priceBlockPoint.4"]

      ],
      buttonText: config.textByLanguage.buyText,
      buttonVariant: "outlined",
      id: config.products.characterPack[100000]
    },

    {
      title: `250,000 ${config.textByLanguage.neuralVoiceCharacters}`,
      price: "$50",
      subheader: "Best Value!",
      description: [
        `250,000 ${config.textByLanguage["priceBlockPoint.1"]}`,
        config.textByLanguage["priceBlockPoint.2"],
        config.textByLanguage["priceBlockPoint.3"],
        config.textByLanguage["priceBlockPoint.4"]

      ],
      buttonText: config.textByLanguage.buyText,
      buttonVariant: "outlined",
      id: config.products.characterPack[250000]
    },


    {
      title: `500,000 ${config.textByLanguage.neuralVoiceCharacters}`,
      price: "$100",
      subheader: "",
      description: [
        `500,000 ${config.textByLanguage["priceBlockPoint.1"]}`,
        config.textByLanguage["priceBlockPoint.2"],
        config.textByLanguage["priceBlockPoint.3"],
        config.textByLanguage["priceBlockPoint.4"]

      ],
      buttonText: config.textByLanguage.buyText,
      buttonVariant: "outlined",
      id: config.products.characterPack[500000]
    },

    {
      title: `1,000,000 ${config.textByLanguage.neuralVoiceCharacters}`,
      price: "$200",
      subheader: "",
      description: [
        `1,000,000 ${config.textByLanguage["priceBlockPoint.1"]}`,
        config.textByLanguage["priceBlockPoint.2"],
        config.textByLanguage["priceBlockPoint.3"],
        config.textByLanguage["priceBlockPoint.4"]

      ],
      buttonText: config.textByLanguage.buyText,
      buttonVariant: "outlined",
      id: config.products.characterPack[1000000]
    },
    {
      title: config.textByLanguage.enterpriseSolution,
      price: "",
      subheader: "",
      description: [
        config.textByLanguage.enterpriseSolutionContactUs,

      ],
      buttonText: config.textByLanguage.enterpriseButtonText,
      buttonVariant: "outlined",
    },
  ];


  // const tiers = [
  //   {
  //     title: "Basic",
  //     price: "FREE",
  //     description: [
  //       "Free text to speech in over 40 languages.",
  //       "Only supports basic voices.",
  //       "1000 free Neural Voice credits.",
  //       "Supports over 10 file formats.",
  //       "Convert any image or PDF to text.",
  //       "Daily limit of 5000 characters/day.",
  //       "Unable to save audio files",
  //       "Unable to voice gender",
  //       "Unable to adjust pitch or speaking rate"

  //     ],
  //     buttonText: "Sign Up For Free!",
  //     buttonVariant: "outlined",
  //     id: 'Basic'
  //   },
  //   {
  //     title: "Pro",
  //     subheader: "/ Month",
  //     price: "$9",
  //     description: [
  //       "Free text to speech in over 40 languages.",
  //       "Access to over 200 voices in 40 languages",
  //       "50,000 free Neural Voice credits.",
  //       "Supports over 10 file formats.",
  //       "Convert any image or PDF to text.",
  //       "Free storage of converted audio files",
  //       "Ability to adjust pitch and speaking rate",
  //       "Ability to choose between .wav or .mp3 audio format"

  //     ],
  //     buttonText: "Sign Up",
  //     buttonVariant: "outlined",
  //     id: config.products.membership.monthly
  //   },
  //   {
  //     title: "Pro",
  //     price: "$99",
  //     subheader: "/ Year",
  //     description: [
  //       "Free text to speech in over 40 languages.",
  //       "Access to over 200 voices in 40 languages",
  //       "500,000 free Neural Voice credits.",
  //       "Supports over 10 file formats.",
  //       "Convert any image or PDF to text.",
  //       "Free storage of converted audio files",
  //       "Ability to adjust pitch and speaking rate",
  //       "Ability to choose between .wav or .mp3 audio format"

  //     ],
  //     buttonText: "Sign Up",
  //     buttonVariant: "outlined",
  //     id: config.products.membership.yearly
  //   },

  // ];

  return (
    <>

      <AppBar
        position="static"
        color="default"
        elevation={0}
        className={classes.appBar}
      ></AppBar>



      {/* <Container maxWidth="sm" component="main" className={classes.heroContent} >
        <Typography
          component="h1"
          variant="h2"
          align="center"
        >
          Monthly Subscription
        </Typography>
        <Typography
          variant="h5"
          align="center"
          color="textSecondary"
          component="p"
        >
          Choose a montly subscription or pay as you go with character packs
        </Typography>
      </Container>
      <Container maxWidth="lg" component="main">
        <Grid container spacing={5} alignItems="flex-end">
          {tiers.map((tier) => (
            // Enterprise card is full width at sm breakpoint
            <Grid
              item
              key={tier.title + (tier.id || '')}
              xs={12}
              sm={tier.title === "Enterprise" ? 12 : 6}
              md={4}
            >
              <Card>
                <CardHeader
                  title={tier.title}
                  subheader={tier.subheader}
                  titleTypographyProps={{ align: "center" }}
                  subheaderTypographyProps={{ align: "center", color: 'inherit' }}
                  action={tier.title === "Pro" ? <StarIcon /> : null}
                  className={classes.cardHeader}
                  style={{ backgroundColor: tier.title === "Pro" ? theme.palette.primary.light : undefined, color: tier.title === "Pro" ? theme.palette.background.paper : undefined }}
                />
                <CardContent>
                  <div className={classes.cardPricing} >
                    <Typography component="h2" variant="h3" color="textPrimary">
                      {tier.price}
                    </Typography>

                  </div>
                  <div>
                    {tier.description.map((line) => (
                      <Typography
                        component="li"
                        variant="subtitle1"
                        align="center"
                        key={line}
                        style={{ marginTop: 32 }}
                      >
                        {line}
                      </Typography>
                    ))}
                  </div>
                </CardContent>
                <CardActions>
                  {!tier.title.startsWith("Enterprise") && !(goingToStripe === tier.id) &&
                    < Button fullWidth color="primary" variant='outlined' disabled={goingToStripe.length > 0 && goingToStripe !== tier.id}
                      style={{ margin: 0, padding: 0, height: 42 }}
                      onClick={tier.id === 'Basic' ? () => dispatch({type:'SET_LOGIN_MODAL', payload:true}) : () => {
                        setGoingToStripe(tier.id || '')
                        const uid = firebase.auth().currentUser?.uid
                        if (tier.id && uid) {
                          sendToCheckout(uid, tier.id)
                        }
                      }}
                    >
                      {tier.buttonText}
                    </Button>}

                  {!tier.title.startsWith("Enterprise") && goingToStripe === tier.id &&
                    < Button fullWidth color="primary" variant='outlined' style={{ margin: 0, padding: 0, height: 42 }}>
                      <CircularProgress size={30} />
                    </Button>}

                </CardActions>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container> */}



      {/* End hero unit */}

      <Container maxWidth="sm" component="main" className={classes.heroContent} >
        <Typography
          component="h1"
          variant="h2"
          align="center"
        >
          {config.textByLanguage["characterPack.title"]}
        </Typography>
        <Typography
          variant="h5"
          align="center"
          color="textSecondary"
          component="p"
        >
          {config.textByLanguage["characterPack.summary"]}
        </Typography>
      </Container>

      <Container maxWidth="lg" component="main" >
        <Grid container spacing={5} alignItems="flex-end">
          {characterPacks.map((tier) => (
            // Enterprise card is full width at sm breakpoint
            <Grid
              item
              key={tier.title}
              xs={12}
              md={4}
            >
              <Card>
                <CardHeader
                  title={tier.title}
                  subheader={tier.subheader}
                  titleTypographyProps={{ align: "center" }}
                  subheaderTypographyProps={{ align: "center", color: 'inherit' }}
                  action={tier.title.startsWith('250') ? <StarIcon /> : null}
                  className={classes.cardHeader}
                  style={{ backgroundColor: tier.title.startsWith('250') ? theme.palette.primary.light : undefined, color: tier.title.startsWith('250') ? theme.palette.background.paper : undefined }}
                />
                <CardContent>

                  <div className={classes.cardPricing} >
                    <Typography component="h2" variant="h3" color="textPrimary">
                      {tier.price}
                    </Typography>

                  </div>
                  <div>
                    {tier.description.map((line) => (
                      <Typography
                        component="li"
                        variant="subtitle1"
                        align="center"
                        key={line}
                        style={{ marginTop: 32 }}
                      >
                        {line}
                      </Typography>
                    ))}
                  </div>
                </CardContent>
                <CardActions>
                  {!tier.title.startsWith("Enterprise") && !(goingToStripe === tier.id) &&
                    < Button fullWidth color="primary" variant='outlined' style={{ margin: 0, padding: 0, height: 42 }}
                      disabled={goingToStripe.length > 0 && goingToStripe !== tier.id}
                      onClick={() => {
                        const uid = firebase.auth().currentUser?.uid
                        if (tier.id && uid) {
                          setGoingToStripe(tier.id || '')
                          sendToCheckout(uid, tier.id)
                        }
                        else {
                          dispatch({ type: 'SET_LOGIN_MODAL', payload: true })
                        }
                      }}>
                      {tier.buttonText}
                    </Button>}

                  {!tier.title.startsWith("Enterprise") && goingToStripe === tier.id &&
                    < Button fullWidth color="primary" variant='outlined' style={{ margin: 0, padding: 0, height: 42 }}>
                      <CircularProgress size={30} />
                    </Button>}

                  {tier.title.startsWith("Enterprise") &&
                    <Button fullWidth color="primary" variant='outlined' style={{ margin: 0, padding: 0, height: 42 }}>
                      <a href="mailto:support@audioanything.com" style={{ padding: 8, color: 'inherit', textDecoration: 'none', width: '100%', height: '100%' }}>{tier.buttonText}</a>
                    </Button>}
                </CardActions>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </>
  );
}
